import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  stroke: "#004132",
  "stroke-miterlimit": "10",
  "stroke-width": "2.417",
  "clip-path": "url(#a)"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20.225 14.152v4.169c0 .664-.544 1.208-1.209 1.208H3.308A1.21 1.21 0 0 1 2.1 18.321V2.613c0-.665.543-1.209 1.208-1.209h4.157M18.906 2.48l-9.062 9.062M11.777 1.393h7.395c.58 0 1.064.47 1.064 1.063V9.85" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M.89.185h20.555v20.554H.89z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }